import React from 'react';
import { PropTypes } from 'prop-types';
import { useTranslation } from 'react-i18next';
import { confirmRevokeCardId } from '../../constants';
import NewCardLayout from '../shared/NewCardLayout';
import {
    PortalContainer,
    StyledAlert,
} from '../../styles/common';

const ConfirmRevoke = ({
    title,
    dispatch,
    state: { disableBack, disableNext },
}) => {
    const { t } = useTranslation();

    return (
        <NewCardLayout
            title={title}
            id={confirmRevokeCardId}
            dispatch={dispatch}
            disableBack={disableBack}
            disableNext={disableNext}
            isBackButtonCancel={true}
        >
            <PortalContainer>
                <StyledAlert color="warning">{t('confirmRevoke$revokingIsFinal')}</StyledAlert>
            </PortalContainer>
        </NewCardLayout>
    );
};

ConfirmRevoke.propTypes = {
    title: PropTypes.string,
    dispatch: PropTypes.func,
    state: PropTypes.object,
};

ConfirmRevoke.defaultProps = {
    title: '',
    instructions: '',
};

export default ConfirmRevoke;
